// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { License } from "./License";
import {
  LicenseFromJSON,
  LicenseFromJSONTyped,
  LicenseToJSON,
  LicenseToJSONTyped,
} from "./License";
import type { IdentityProvider } from "./IdentityProvider";
import {
  IdentityProviderFromJSON,
  IdentityProviderFromJSONTyped,
  IdentityProviderToJSON,
  IdentityProviderToJSONTyped,
} from "./IdentityProvider";

/**
 *
 * @export
 * @interface TenantUpdate
 */
export interface TenantUpdate {
  /**
   *
   */
  name?: string | null;
  /**
   *
   */
  identityProviders?: Array<IdentityProvider> | null;
  /**
   *
   */
  threediOrganisations?: Array<string> | null;
  /**
   *
   */
  description?: string | null;
  /**
   *
   */
  license?: License | null;
}

/**
 * Check if a given object implements the TenantUpdate interface.
 */
export function instanceOfTenantUpdate(value: object): value is TenantUpdate {
  return true;
}

export function TenantUpdateFromJSON(json: any): TenantUpdate {
  return TenantUpdateFromJSONTyped(json, false);
}

export function TenantUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantUpdate {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"] === undefined ? undefined : json["name"] === null ? null : json["name"],
    identityProviders:
      json["identity_providers"] === undefined
        ? undefined
        : json["identity_providers"] === null
        ? null
        : (json["identity_providers"] as Array<any>).map(IdentityProviderFromJSON),
    threediOrganisations:
      json["threedi_organisations"] === undefined
        ? undefined
        : json["threedi_organisations"] === null
        ? null
        : json["threedi_organisations"],
    description:
      json["description"] === undefined
        ? undefined
        : json["description"] === null
        ? null
        : json["description"],
    license:
      json["license"] === undefined
        ? undefined
        : json["license"] === null
        ? null
        : LicenseFromJSON(json["license"]),
  };
}

export function TenantUpdateToJSON(json: any): TenantUpdate {
  return TenantUpdateToJSONTyped(json, false);
}

export function TenantUpdateToJSONTyped(
  value?: TenantUpdate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    identity_providers:
      value["identityProviders"] == null
        ? undefined
        : (value["identityProviders"] as Array<any>).map(IdentityProviderToJSON),
    threedi_organisations: value["threediOrganisations"],
    description: value["description"],
    license: LicenseToJSON(value["license"]),
  };
}
